










import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ContainerPage extends Vue {
  @Prop(String) readonly title: string;
}
